<template>
	<div class="layout-footer flex-column">
		<span>© Viomba {{new Date().getFullYear()}} | Kaikukatu 2C, 00530 HELSINKI, Finland</span>
	</div>
</template>